<template>
  <div class="footer">
    <!-- <div class="info contact">
      <img  @dragstart.prevent  src="../assets/icon_weixin.png" class="icon" alt="" @mouseover="chengeOver()" @mouseout="changeOut()"/>
      <img  @dragstart.prevent  src="../assets/icon_youxiang.png" class="icon"  style="margin-left: 50px;cursor: pointer;"  alt="" @click="yxbtnClick"/>
      <div class="hoverMa flex-center" v-show="vactive">
        <img  @dragstart.prevent  src="../assets/wxkefu.jpg" class="icon" alt="" />
      </div>
    </div> -->
    <div class="info mainInfo">
      <div class="mainInfo-left">
        <p>太原巴卡巴科技</p>
        <p>全部信息 太原巴卡巴科技 版权所有未经许可严禁转载</p>
        <!-- <p>Copyright ©2018-2024 zhangwen.cn All Rights Reserved</p> -->
      </div>
      <div class="mainInfo-right">
        <table>
          <tr>
		<!-- path = '/personal/personalComponents/userAgreement' -->
            <td @click="navTos(1)">首页</td>
            <td @click="navTos(13)">关于我们</td>
            <td @click="navTos(24)">充值中心</td>
            <td @click="navTos(0,7)">退款中心</td>
            <!-- <td @click="navTos('/home')" style="width: 65px">退款协议</td> -->
          </tr>
          <tr>
            <td @click="navTos(0,5)">用户协议</td>
            <td @click="navTos(0,6)">隐私协议</td>
            <td @click="navTos(0,10)">用户纠纷处理</td>
            <td @click="navTos(0,11)">未成年保护制度</td>
          </tr>
          <tr>
            <td @click="navTos(14)">联系我们</td>
            <td @click="yxbtnClick">邮箱投稿</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="dashLine"></div>
    <div class="info certificateInfo">
      <p class="hang1">
        <!-- <img  @dragstart.prevent  src="../assets/logo_single.png" class="logo" alt="" />
        <a :href="require('../assets/yinye_cer.jpg')" target="_blank">营业执照</a>
        <span class="gang">|</span> -->
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">晋ICP备2023017375号-1</a>
        <!-- <span class="gang">|</span>
        <a :href="require('../assets/dianxin_cer.jpg')" target="_blank">增值电信业务经营许可证京 B2-20191878</a>
        <span class="gang">|</span>
        <a :href="require('../assets/wenwangwen.jpg')" target="_blank">网络文化经营许可证京网文(2024)0429-022号</a> -->
      </p>
      <!-- <p>
        <a :href="require('../assets/chuban_cer.jpg')" target="_self">出版物经营许可证</a>
        新出发 京零 字第朝200281号<span class="gang">|</span>
        <a :href="require('../assets/guangbojingying.jpg')" target="_blank">广播电视节目制作经营许可证 (京)字第 24919号</a>
      </p> -->
      <p>
        <!-- ------------这个地方有问题？？？？？？？？？？？？？？？？？？？？？ -->
        <span class="cursorPointer" style="color:#fff" @click="navTos(0,10)">纠纷处理</span>
        <span class="gang">|</span>
        <span class="dian" @click="yxbtnClick">举报邮箱:13121557965@163.com</span>
        <span class="gang">|</span>
        <a href="https://jbts.mct.gov.cn/" target="_blank" >12318全国文化市场举报网站</a>
        <span class="gang">|</span>
        <a href="https://www.12377.cn/" target="_blank">中国互联网不良信息举报中心</a>
      </p>
      <p>
        工作时间：上午10:00-12:00 下午13:00-18:00<span class="gang">|</span>
        前台电话：15840721070<span class="gang">|</span>举报电话：15840721070
      </p>
    </div>
    <!-- <a href="https://beian.miit.gov.cn/" target="_blank">备案信息参照：京ICP备14010450号-1</a>
        <a :href="require('../assets/img.png')" target="_blank">京ICP证：京B2-20191878号</a>
        <p>
        <a
		:href="require('../assets/bc.png')"
          target="_blank"
          >网络文化经营许可证 京网文（2021）</a
        >
        0463-113号
      </p>
    -->
  </div>
</template>
<script type="text/javascript">
import { navTo } from '../utils/utils'
export default {
  data() {
    return {
      vactive:false
    };
  },
  methods: {
    about() {
      this.$router.push("/about");
    },
    yxbtnClick(){
      window.location.href = "mailto:beijingzhangwen@zhangwen.cn?subject=Subject&body=message%20goes%20here";
    },
    navTos(type,miniID){
      let path = ''
      let query = {}
      if(type == 1){
        path = '/home'
      }else if(type == 13 || type == 24 || type == 14){
        path = '/personal/personalComponents/personalCenter'
		    query={id:type}
        let str = `${path}?id=${type}`
    	  localStorage.setItem('currPath',str)
      }else if(type == 0){
        path = '/personal/personalComponents/userAgreement'
		    query={id:type,miniID,open:true}
        let str = `${path}?id=${type}&miniID=${miniID}&open=true`
    	  localStorage.setItem('currPath',str)
      }
      navTo(path,query)
    },
    chengeOver(){
      this.vactive = true;
    },
    changeOut(){
      this.vactive = false;
    },
  },
};
</script>
<style lang="scss" scoped="scoped" type="text/css">
.footer {
  background-color: #363347;
  padding: 51px 0 30px;
  display: flex;
  flex-direction: column;
  p,
  a,
  td {
    line-height: 36px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
  }
  .info {
    min-width: 1188px;
    margin: 0 auto;
  }
  .contact {
    display: flex;
    margin-bottom: 35px;
    position: relative;
    p,
    a,
    td {
      color: #888 !important;
    }
    .icon {
      height: 30px;
      margin-bottom: 14px;
    }
    .hoverMa{
      position: absolute;
      top: -110px;
      left: -47px;
      width: 110px;
      height: 111px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
      background-image: url('../assets/bg_qipao.png');
      img{
        width: 70px;
        height: 70px;
      }
    }
  }

  .mainInfo {
    display: flex;
    justify-content: space-between;
    p {
      text-align: left;
    }
    p,
    a,
    td {
      color: #888 !important;
    }
    td:hover{
      color: #fff !important;
    }
    a:hover{
      color: #fff !important;
    }
    p:hover{
      color: #fff !important;
    }
    table {
      td {
        width: 120px;
        text-align: left;
        cursor: pointer;
      }
    }
  }
  .dashLine {
    height: 2px;
    border: 1px dashed #464646;
    margin: 35px 0 ;
  }
  .certificateInfo {
    .logo {
      width: 13px;
      height: 12px;
      margin-right: 2px;
    }
    .hang1 {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .gang {
      margin: 0 4px;
      line-height: 36px;
      font-size: 14px;
      color: #fff;
    }
    .dian{
      cursor: pointer;
      color: #fff;
    }
  }
}
a {
  text-decoration: none;
}

</style>
